import { union } from 'lodash';

const getPercentageForAllDocuments = (documents) => {
  let totalPercentage = 0;
  totalPercentage += documents.reduce((acc, document) => {
    return acc + document.percentage;
  }, 0);

  return totalPercentage;
};

const getAllDocumentsForMarker = (marker) => {
  let documents = marker.documents;

  if (marker.children.length > 0) {
    let childDocuments = marker.children.reduce((acc, item) => {
      return acc.concat(item.documents);
    }, []);
    documents = union(documents, childDocuments);
  }

  return documents;
};

// Calculates the total percentage of a marker's document.percentage and all of its children's document.percentage.
// We will need to update the backend & processing to be able to accurately reflect percentages for markers that share a document with their parent in the future.
// Currently if a marker shares a document with its parent, it will use the same number for document.percentage. This is not an accurate representation of the marker's percentage to display for the user.
export const getMarkerPercentageTotal = (marker) => {
  let markerDocuments = getAllDocumentsForMarker(marker);

  let percentageForAllDocuments = getPercentageForAllDocuments(markerDocuments);

  return percentageForAllDocuments;
};

// If child shares a document with its parent and has no children, do not show its percentage because it is the same percentage amount as its parent.
// This is not an accurate representation of the marker's percentage to display for the user.
export const getShouldShowPercentage = (marker) => {
  if (
    !marker.children?.length &&
    marker.parent &&
    marker.parent.document.index === marker.document.index
  ) {
    return false;
  } else {
    return true;
  }
};
